import { Link } from 'react-router-dom';
import { billtoroKacheln } from '../billtoro/kacheln';
import type { Tarif } from '../billtoro/types';
import { isBilltoro } from '../produkt';

const BILLTORO = isBilltoro();

// „Mehr“ im Menü: die selteneren Bereiche als große Kacheln (am Handy passt nicht alles in die Leiste). Billtoro hat
// dazu Zeiten, Lager, Tarif, Team, Steuerbüro, Konto und „Firma anlegen“ (Seiten in src/billtoro, Konto über das Menü oben rechts).
export const MEHR_PFADE = [
  'leistungen',
  'wiederkehrend',
  'mahnlauf',
  'einstellungen',
  'angaben',
  'mehr',
  ...(BILLTORO ? ['zeiten', 'lager', 'tarif', 'team', 'steuerbuero', 'konto', 'firma-neu'] : []),
];

// Billtoro: Zeiten, Lager, Tarif, Team und Steuerbüro je nach Rolle und Tarif (billtoro/kacheln.ts)
const kacheln = (tarif: Tarif | null | undefined): [string, string, string][] => [
  ['/rechnung/leistungen', 'Leistungen und Artikel', 'Eigene Leistungen mit Preis und Einheit, beim Schreiben vorgeschlagen'],
  ['/rechnung/wiederkehrend', 'Wiederkehrende Rechnungen', 'Feste Aufträge jeden Monat oder jedes Quartal von selbst'],
  ['/rechnung/mahnlauf', 'Mahnläufe', 'Überfällige Rechnungen von selbst erinnern und mahnen'],
  ['/rechnung/einstellungen', 'Einstellungen', 'Logo, Farbe und eigene Rechnungsnummern'],
  ['/rechnung/angaben', 'Meine Angaben', 'Firma, Steuernummer, Bankverbindung und Pflichtangaben'],
  ...(BILLTORO ? billtoroKacheln(tarif) : []),
];

export function Mehr({ tarif }: { tarif?: Tarif | null }) {
  return (
    <>
      <div className="rt-head">
        <h1>Mehr</h1>
      </div>
      <ul className="rt-mehr">
        {kacheln(tarif).map(([to, title, text]) => (
          <li key={to}>
            <Link to={to}>
              <strong>{title}</strong>
              <span>{text}</span>
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
}
